module.exports = __webpack_public_path__ + "static/media/strades.7be8290e.png";